<template>
	<div class="bg-white">
		<ul v-if="predictions.length > 0" class="ma-0 pa-0 d-flex flex-column gap-4">
			<li
				v-for="prediction in predictions"
				:key="prediction.placeId"
				class="d-flex cursor-pointer"
				style="list-style: none"
				@click="$emit('select', prediction)"
			>
				<div class="d-flex flex-column">
					<h3 class="text-body-m text-neutral-950 font-weight-bold">{{ prediction.name }}</h3>
					<p v-if="prediction.address" class="text-body-m text-neutral-800">
						{{ prediction.address }}
					</p>
				</div>
				<div
					class="pa-2 bg-neutral-25 rounded-2 align-self-center"
					style="margin-left: auto; height: 32px; width: 32px"
				>
					<NewIcon icon="arrow-right" />
				</div>
			</li>
		</ul>
		<div v-else-if="!isLoading && searchText.length > minLength && predictions.length === 0">
			{{ $t('search_common_noresults_tryagain') }}
		</div>
		<div v-else-if="!isLoading">
			<slot name="emptyState" />
		</div>
		<div class="width-full pt-4 d-flex justify-end">
			<img src="~/assets/google-maps-gray-logo.svg" alt="Powered by Google" height="16px" />
		</div>
		<div v-if="showAllResultsButton && !isLoading && predictions.length" class="mt-4">
			<PButton
				color="neutral"
				type="outlined"
				style="width: 100%"
				@click="$emit('show-all-results')"
			>
				<div class="d-flex gap-2">
					<p>{{ $t('web.common.search.action.see_all_results') }}</p>
					<NewIcon class="align-self-center" icon="arrow-right" />
				</div>
			</PButton>
		</div>
	</div>
</template>
<script setup lang="ts">
	import { GooglePlace } from '~/models/GPlace'

	interface Props {
		predictions: GooglePlace[]
		searchText?: string
		searchFromStart?: boolean
		isLoading?: boolean
		minLength?: number
		showAllResultsButton?: boolean
	}

	withDefaults(defineProps<Props>(), {
		minLength: 3,
		searchText: '',
		isLoading: false,
	})
	defineEmits(['select', 'show-all-results'])
</script>
